import React from "react";
import { createTheme } from "@mui/material/styles";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { get, set } from "idb-keyval";
import { db } from "./common/lib/";
import actions from "./Store/actions";
import { useCurrentTheme } from "./common/hooks";
import { cvTheme, uverifiTheme } from "./common/styles";
import config from "./config";
import { updateSentryUserContext } from "./config/Sentry";
/**
 * Connection Change Listener Hook
 */
export const AppSupportProvider = ({ children }) => {
    const { auditAssets, app, auth } = useSelector((state) => state);
    const { baseUrl } = config.api;
    const dispatch = useDispatch();

    const isCheckVentory = baseUrl.includes("checkventory");
    const currentEnvTheme = isCheckVentory ? cvTheme : uverifiTheme;

    // Update Sentry user context when app starts
    useEffect(() => {
        updateSentryUserContext();
    }, [auth]);

    /** Fail safe if in case anything is not returned  */
    const theme = createTheme(
        useCurrentTheme() ? useCurrentTheme() : currentEnvTheme
    );

    useEffect(() => {
        // initialiaze connection
        // console.log("window.navigator.onLine", window.navigator.onLine);

        dispatch(
            actions.app.create.update({ netConnected: window.navigator.onLine })
        );

        window.addEventListener("offline", () => {
            dispatch(actions.app.create.update({ netConnected: false }));
        });
        window.addEventListener("online", () => {
            dispatch(actions.app.create.update({ netConnected: true }));
        });

        return () => {
            window.removeEventListener("offline", () => {
                actions.app.create.update({ netConnected: false });
            });
            window.removeEventListener("online", () => {
                actions.app.create.update({ netConnected: true });
            });
        };
    }, [dispatch, window.navigator.onLine]);

    /*
        Preassemble a search data 
    */
    useEffect(async () => {
        if (auditAssets.data.length === 0) return;

        let results = await get(db.types.auditAsset);
        if (!results) results = [];

        let cachedData = await get(db.types.searchCache);
        let typesListData = await get(db.types.typesList);

        /** Get make for every asset based on the org */
        const getMake = (makeId, orgId) => {
            /** check for the org id in typesList */
            const currentTypesList = typesListData.find(
                (item) => item.orgId === orgId
            );

            /** If typesList  present find the make */
            const currentMake =
                currentTypesList &&
                currentTypesList.typesList.makes.find(
                    (item) => item.id === makeId
                );

            /** if make present return  make else return empty */
            return currentMake && currentMake.name ? currentMake.name : "";
        };

        /** Get model for every asset based on the org */
        const getModel = (assetAttributes, orgId) => {
            const currentTypesList = typesListData.find(
                (item) => item.orgId === orgId
            );

            /** Model id  of attrubute is 1
             *  Using id because of language translation
             */
            const modelId = 1;
            const currentModel =
                currentTypesList &&
                currentTypesList.typesList.attributes.find(
                    (item) => item.id === modelId
                );

            const res =
                currentModel &&
                assetAttributes &&
                assetAttributes.find(
                    (item) => item.attribute === currentModel.id
                );
            return res && res.value ? res.value : "";

            /** get model details  */
        };

        /*
            update search cache when it is not found in db and count of assets in redux 
            is not equal to the count in db
        */
        if (!cachedData || results.length !== cachedData.length) {
            cachedData = [];

            results.forEach((item, index) => {
                const { id } = item.auditLocation.audit.organisation;
                const { assetAttributes } = item;
                const { identifier1, identifier2, make } = item.assetCore;

                const makeStr = getMake(make, id);
                const model = getModel(assetAttributes, id);

                cachedData.push(
                    `${identifier1} ${identifier2} ${makeStr} ${model}`.toLowerCase()
                );
            });

            console.info("Search cache rebuilt");
            // save search result to db
            await set(db.types.searchCache, cachedData);
        }
    }, [auditAssets.byId]);

    // !important we need to make sure that ReduxState from DB gets loaded first
    if (!app.reduxStateLoaded) return null;

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
